//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
  mdiChevronRight,
  mdiInformationOutline,
} from '@mdi/js'
import { computed, useSlots } from '@vue/composition-api'

export default {
  name: 'VideoCard',
  props: {
    showArrow: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    showBorderGray: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const slots = useSlots()

    const hasIconContent = computed(() => !!slots.icon)
    const borderCardStyle = computed(() => {
      let strStyle = ''
      if (props.showBorder) {
        strStyle = 'border: 1px solid rgba(255, 50, 50, 0.50) !important; box-shadow: 0px 4px 4px 0px rgba(255, 50, 50, 0.25) !important;'
      } else if (props.showBorderGray) {
        strStyle = 'box-shadow: 0px 4px 4px 0px rgba(51, 51, 51, 0.25) !important;'
      }

      return strStyle
    })

    return {
      hasIconContent,
      borderCardStyle,

      icons: {
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        mdiChevronRight,
        mdiInformationOutline,
        play: require('@/assets/images/svg/play.svg'),
      },
    }
  },
}
